<section class="header" data-region="header"></section>
<section class="manage-columns" data-region="manageColumns"></section>
<section class="content {{#if disableDynamicColumnWidths}}static-width-table-layout{{/if}}" data-region="content"></section>
{{#if showLoaderOnFilter}}
    <section class="loader grid-loader hidden"></section>
{{/if}}
<section class="footer" data-region="footer"></section>
